"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { StarRating } from "./StarRating";
import Image from "next/image";
interface Review {
  id: string;
  name: string;
  avatar?: string | null;
  rating: number;
  content: string;
  date: string;
  sourceUrl?: string;
}
interface ReviewCardProps {
  testimonial: Review;
}
const DEFAULT_AVATAR = "https://ik.imagekit.io/senja/tr:f-jpeg/Avatars/avatar_aOgsMJ-eZ.png?ik-sdk-version=javascript-1.4.3&updatedAt=1657796891741";
const TRUSTPILOT_LOGO = "https://ik.imagekit.io/senja/tr:w-40,f-png/Logos/trustpilot-logo_Hdn_TGo6b.png?updatedAt=1683237856080";
export const ReviewCard = t0 => {
  const $ = _c(29);
  const {
    testimonial
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const shouldTruncate = testimonial.content.length > 150 && !isExpanded;
  const t1 = testimonial.avatar || DEFAULT_AVATAR;
  const t2 = `${testimonial.name} avatar`;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = <div className="flex-none"><Image src={t1} alt={t2} className="h-[42px] w-[42px] rounded-full object-cover" loading="lazy" referrerPolicy="no-referrer" width={42} height={42} quality={60} /></div>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== testimonial.name) {
    t4 = <div className="min-w-0 flex-1"><div className="truncate text-sm font-medium text-gray-900">{testimonial.name}</div></div>;
    $[3] = testimonial.name;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== testimonial.sourceUrl) {
    t5 = testimonial.sourceUrl && <div className="flex-none"><a href={testimonial.sourceUrl} target="_blank" rel="nofollow noopener noreferrer"><Image src={TRUSTPILOT_LOGO} alt="trustpilot" width={20} height={20} loading="lazy" className="h-5 w-5 object-contain" /></a></div>;
    $[5] = testimonial.sourceUrl;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <div className="mb-2 flex items-center gap-3">{t3}{t4}{t5}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== testimonial.rating) {
    t7 = <StarRating rating={testimonial.rating} />;
    $[11] = testimonial.rating;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = shouldTruncate ? "line-clamp-4 overflow-hidden" : "";
  let t9;
  if ($[13] !== t8 || $[14] !== testimonial.content) {
    t9 = <div className={t8}>{testimonial.content}</div>;
    $[13] = t8;
    $[14] = testimonial.content;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isExpanded || $[17] !== testimonial.content.length) {
    t10 = testimonial.content.length > 150 && <button onClick={() => setIsExpanded(!isExpanded)} className="mt-1 cursor-pointer border-none bg-transparent text-sm text-gray-700 opacity-80 hover:opacity-100"><span>{isExpanded ? "Show less" : "Read more"}</span></button>;
    $[16] = isExpanded;
    $[17] = testimonial.content.length;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className="my-2 flex-1 text-left text-sm text-gray-700">{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== testimonial.date) {
    t12 = <div className="mt-auto pt-2 text-xs text-gray-500">{testimonial.date}</div>;
    $[22] = testimonial.date;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12 || $[26] !== t6 || $[27] !== t7) {
    t13 = <div className="h-full w-full"><div className="flex h-full flex-col rounded-lg bg-white p-4 text-left shadow-sm"><div className="flex h-full flex-col">{t6}{t7}{t11}{t12}</div></div></div>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t6;
    $[27] = t7;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};